(() => {
  const OPEN_BODY_CLASS = 'cart-sidebar-show';
  const PREVIEW_SELECTOR = '.previewCart';

  // Geschwindigkeit: 1px alle 35ms ≈ 28px/s
  const STEP_PX = 1;
  const INTERVAL_MS = 35;
  const START_DELAY_MS = 250;

  let timer = null;
  let userInteracted = false;
  let openToken = 0;
  let lastOpen = document.body.classList.contains(OPEN_BODY_CLASS);

  const isOpen = () => document.body.classList.contains(OPEN_BODY_CLASS);

  const hardStop = () => {
    userInteracted = true;
    if (timer) clearInterval(timer);
    timer = null;
  };

  const armStopOnlyInsidePreviewCart = (previewEl) => {
    if (!previewEl || previewEl.__autoScrollArmed) return;
    previewEl.__autoScrollArmed = true;

    // Stop wirklich NUR bei Interaktion IN previewCart
    ['pointerdown', 'mousedown', 'touchstart', 'wheel'].forEach(evt => {
      previewEl.addEventListener(evt, hardStop, { passive: true });
    });
  };

  const tick = (token) => {
    if (token !== openToken) return;
    if (!isOpen()) return hardStop();
    if (userInteracted) return;

    // Wichtig: JEDEN Tick neu holen, weil Halo den Bereich gern ersetzt
    const preview = document.querySelector(PREVIEW_SELECTOR);
    if (!preview) return;

    armStopOnlyInsidePreviewCart(preview);

    const max = preview.scrollHeight - preview.clientHeight;
    if (max <= 1) return; // noch nicht scrollbar / noch nicht fertig gerendert

    const next = Math.min(max, preview.scrollTop + STEP_PX);
    preview.scrollTop = next;

    // Am Ende stoppen
    if (next >= max - 1) hardStop();
  };

  const start = () => {
    userInteracted = false;
    openToken++;

    if (timer) clearInterval(timer);
    const token = openToken;

    timer = setInterval(() => tick(token), INTERVAL_MS);
  };

  const onOpen = () => {
    if (timer) clearInterval(timer);
    timer = null;
    userInteracted = false;

    setTimeout(() => {
      if (isOpen()) start();
    }, START_DELAY_MS);
  };

  // Nur body.class beobachten
  const obs = new MutationObserver(() => {
    const nowOpen = isOpen();
    if (nowOpen && !lastOpen) onOpen();
    if (!nowOpen && lastOpen) hardStop();
    lastOpen = nowOpen;
  });

  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // falls beim Laden schon offen
  if (lastOpen) onOpen();
})();
